/* IC ORIGIN SEO CONTENT v2.0 — loader pentru pagini /pages/origini-* */
(function() {
  'use strict';
  function getPageHandle() {
    var path = location.pathname || '';
    var m = path.match(/\/pages\/([\w-]+)/);
    return m ? m[1] : '';
  }
  function findContainer() {
    return document.querySelector('main, #MainContent, .main-content, .wrap, .page-container') || document.body;
  }
  function injectJsonLd(id, data) {
    var existing = document.getElementById(id);
    if (existing) existing.remove();
    var script = document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);
  }
  function renderOriginContent() {
    var handle = getPageHandle();
    if (!window.IC_ORIGIN_DATA) return;
    var data = window.IC_ORIGIN_DATA[handle];
    if (!data) return;
    if (document.getElementById('ic-origin-seo-block')) return;
    var container = findContainer();
    if (!container) return;
    var section = document.createElement('section');
    section.id = 'ic-origin-seo-block';
    section.className = 'ic-extra-content ic-extra-origin';
    var html = '';
    if (data.introH2) html += '<h2 class="ic-origin-main-title">' + data.introH2 + '</h2>';
    (data.sections || []).forEach(function(s, idx) {
      if (idx > 0) html += '<div class="ic-extra-divider"></div>';
      if (s.eyebrow) html += '<div class="ic-eyebrow">' + s.eyebrow + '</div>';
      if (s.h2) html += '<h2>' + s.h2 + '</h2>';
      (s.paragraphs || []).forEach(function(p) { html += '<p>' + p + '</p>'; });
      if (s.list && s.list.length) {
        html += '<ul>';
        s.list.forEach(function(li) { html += '<li>' + li + '</li>'; });
        html += '</ul>';
      }
      (s.extraParagraphs || []).forEach(function(p) { html += '<p>' + p + '</p>'; });
    });
    if (data.faq && data.faq.length) {
      html += '<div class="ic-extra-divider"></div>';
      html += '<div class="ic-eyebrow">Întrebări frecvente</div>';
      html += '<h2>Despre cafeaua din ' + data.country + ' — întrebări frecvente</h2>';
      data.faq.forEach(function(f) {
        html += '<div class="ic-faq-item">';
        html += '<h3 class="ic-faq-q">' + f.q + '</h3>';
        html += '<p class="ic-faq-a">' + f.a + '</p>';
        html += '</div>';
      });
      injectJsonLd('ic-schema-faq-origin', {
        '@context': 'https://schema.org', '@type': 'FAQPage',
        'mainEntity': data.faq.map(function(f) {
          return { '@type': 'Question', 'name': f.q, 'acceptedAnswer': { '@type': 'Answer', 'text': f.a } };
        })
      });
    }
    section.innerHTML = html;
    container.appendChild(section);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderOriginContent);
  } else {
    renderOriginContent();
  }
})();
